import { z } from 'zod'

export const WithExpiresAtSchema = z.object({
  expiresAt: z.number().describe('aka time to live (ttl), measured in seconds that this item will expiree'),
})

export type WithExpiresAt = z.infer<typeof WithExpiresAtSchema>

export type WithOptionalExpiresAt = Partial<WithExpiresAt>
